import { useDutchiePay } from 'src/payments/hooks';
import useUser from 'hooks/use-user';
import { EntityTypes, useUnenrollPayByBankUserMutation } from 'types/graphql';
import { getLogger } from 'src/utils/datadog-logger';
import { LOG_NAMESPACES } from 'src/payments/constants';

const logger = getLogger(LOG_NAMESPACES.PBB);

export type UseUnenrollPayByBankUserReturn = {
  handleUnenrollPayByBank: () => Promise<{ success: boolean }>;
  isEnrolledDutchiePay: boolean;
};

export const useUnenrollPayByBankUser = (): UseUnenrollPayByBankUserReturn => {
  const User = useUser();
  const { isEnrolledDutchiePay } = useDutchiePay();
  const [unenrollPayByBankUser] = useUnenrollPayByBankUserMutation();

  const handleUnenrollPayByBank = async (): Promise<{ success: boolean }> => {
    try {
      const { data } = await unenrollPayByBankUser({
        variables: { entityId: User?.id, entityType: EntityTypes.user },
      });
      if (!data?.unenrollPayByBankUser.success) {
        throw new Error('Unenrollment failed');
      }
      User.resetUserPayByBankEnrollmentStatus();
      return { success: true };
    } catch (error) {
      console.error(error);
      logger.error('useUnenrollPayByBankUser Error', { error, userId: User?.id ?? 'unknown' });
      return { success: false };
    }
  };

  return { handleUnenrollPayByBank, isEnrolledDutchiePay };
};
